import { Route } from '../ARoute'

export default Route.withPageLayout('khong-gian-lam-viec').addChildren([
  Route.withPath('/', 'workspaces/workspaces-main')
    .withName('workspaces')
    .withTitle('sidebar.workspace.name'),
  Route.withPath(':id', 'workspaces/workspace-detail')
    .withProps()
    .requireHasAnyInScopes(['workspace-management'])
    .addChildren([
      // Route.withPath('ban-do', 'layer-group/layer-group-main')
      //   .withTitle('sidebar.map.name')
      //   .withName('workspace.maps')
      //   .withProps(),
      Route.withPath('lop-ban-do', 'layers/layer-main')
        .withTitle('sidebar.layer.name')
        .withName('workspace.layers')
        .withProps(),
      Route.withPath('bo-du-lieu', 'datastores/datastore-main')
        .withTitle('sidebar.datastore.name')
        .withName('workspace.datastores')
        .withProps(),
      Route.withPath('trinh-bay', 'styles/style-main')
        .withTitle('sidebar.style.name')
        .withName('workspace.styles')
        .withProps(),
    ])
    .withProps(),
])
